<template>
	<div class="productsShowbox">
		<div class="producboxcontent">
			<div class="producbanner">
				<el-carousel :interval="5000" arrow="always" indicator-position='none'>
				    <el-carousel-item v-for="(item,index) in bannerList" :key="item.url+index" >
				      <div class="bannerimgbox">
						  <img :src="item.image" @click="bannerTo(item.url)"/>
						  <div class="imgtitbox">
							<p class="bigimgtit">{{item.title}}</p>
							<!--<p class="bigimgtit">{{item.description}}</p>-->
						  </div>
					  </div>
				    </el-carousel-item>
				</el-carousel>
			</div>
			<div class="procont">
				<div class="inline proimg" v-for="(item,index) in list">
					<a href="#">
						<img :src="item.image" />
					</a>
				</div>
			</div>
			<div class="prolookmore">
				<el-button type="warning" v-if="!isLastPage" @click="getMoreData" round>加&nbsp;载&nbsp;更&nbsp;多</el-button>
			</div>
		</div>
	</div>
</template>

<script>

export default {
    name: 'productDisplay',
    watch:{
        $route(val){
            this.pageName = val.params.id;
            this.cat_id = val.params.id;
            this.init();
        },
        pageName(val){
            //除了加载时，根据pagename判断加载相应数据
        }
    },
    data () {
        return {
            pageName:'restaurant',
            bannerList:[],
            cat_id:0,
            list:[],
            page:1,
            isLastPage: false,
            dataArray: [],
        }
    },
    mounted() {

        this.$nextTick(()=>{
            this.pageName = this.$route.params.id;
            this.cat_id = this.$route.params.id;
            this.getBanner();
            this.getProductList();
            this.$router.afterEach((to, from, next) => {
                window.scrollTo(0, 0)
            })
        });


    },
    methods:{

        init: async function () {
            this.page = 1;
            this.list = [];
            this.isLastPage = false;
            this.getBanner();
            this.getProductList();
        },
        getBanner: async function () {
            const res = await this.$getJSON('/index/bannersByKey',{cat_idname:"product_top_cat_id_"+this.cat_id});
            this.bannerList = res.data.list;
        },
        getMoreData: async function () {
            if (!this.isLastPage) {
                this.page++;
                this.getProductList();
            }
        },
        // 加载产品
        getProductList: async function () {
            const res = await this.$getJSON('/index/productList',{page:this.page, cat_id:this.cat_id});
//            this.list = res.data.list;
            this.list = this.list.concat(res.data.list);
            this.isLastPage = res.data.isLastPage;
        },
        bannerTo: function (url) {
            if(url === ""){
                return;
            } else if(url.substring(0, 1) == "/") {
                this.$router.push({path: url})
            } else {
                window.location.href = url;
            }
        }
    }
}
</script>

<style scoped="scoped">
	.productsShowbox{
		width: 1200px;
		margin: 18px auto;
	}
	.producboxcontent{
		padding-bottom: 40px;
	}
	.prolookmore{
		margin-top: 40px;
	}
	.proimg img{
		width: 370px;
		height: 326px;
	}
	.proimg{
		margin-top: 36px;
	}
	.proimg:not(.proimg:nth-child(3n)){
		margin-right: 27px;
	}
	.producbanner{
		padding-bottom: 20px;
		border-bottom: 1px solid #deb540;
	}
	
	.imgtitbox{
		margin: 35px auto;
	}
	.bigimgtit{
		color: #deb540;
		font-size: 20px;
		line-height: 30px;
		letter-spacing: 2px;
	}
</style>


// WEBPACK FOOTER //
// src/vew/productDisplay.vue